const AuthLayout = ({ children }) => {
    return (
      <div className="auth-page">
        {children}
      </div>
    );
  };
  
  export default AuthLayout;
  